/**
 * Pixel Cart combines line items and order summary in one section.
 * Dawn cart.js expects separate sections, each with a single .js-contents target.
 * Override section selectors so AJAX updates map to the correct DOM nodes.
 */
(function () {
  function isPixelCartPage() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    return items && footer && items.dataset.id && items.dataset.id === footer.dataset.id;
  }

  function patchCartItems() {
    if (!isPixelCartPage() || typeof CartItems === 'undefined') return;

    if (CartItems.prototype.__pixelCartPatched) return;
    CartItems.prototype.__pixelCartPatched = true;

    var defaultGetSectionsToRender = CartItems.prototype.getSectionsToRender;

    CartItems.prototype.getSectionsToRender = function () {
      var sections = defaultGetSectionsToRender.call(this);
      return sections.map(function (section) {
        if (section.id === 'main-cart-footer') {
          return Object.assign({}, section, { selector: '.pixel-cart-footer__contents' });
        }
        return section;
      });
    };

    CartItems.prototype.getSectionInnerHTML = function (html, selector) {
      var doc = new DOMParser().parseFromString(html, 'text/html');

      if (selector === '.js-contents') {
        var itemsRoot = doc.getElementById('main-cart-items');
        if (itemsRoot) {
          var itemsContents = itemsRoot.querySelector('.js-contents');
          if (itemsContents) return itemsContents.innerHTML;
        }
      }

      if (selector === '.pixel-cart-footer__contents') {
        var footerRoot = doc.getElementById('main-cart-footer');
        if (footerRoot) {
          var footerContents = footerRoot.querySelector('.pixel-cart-footer__contents');
          if (footerContents) return footerContents.innerHTML;
        }
      }

      var node = doc.querySelector(selector);
      return node ? node.innerHTML : '';
    };

    var defaultOnCartUpdate = CartItems.prototype.onCartUpdate;

    CartItems.prototype.onCartUpdate = function () {
      if (!isPixelCartPage()) {
        return defaultOnCartUpdate.call(this);
      }

      var sectionId = document.getElementById('main-cart-items').dataset.id;
      return fetch(window.routes.cart_url + '?section_id=' + sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(
          function (responseText) {
            var html = new DOMParser().parseFromString(responseText, 'text/html');
            var sourceContents = html.querySelector('#main-cart-items .js-contents');
            var targetContents = document.querySelector('#main-cart-items .js-contents');

            if (sourceContents && targetContents) {
              targetContents.innerHTML = sourceContents.innerHTML;
            }
          }
        )
        .catch(function (error) {
          console.error(error);
        });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartItems);
  } else {
    patchCartItems();
  }
})();
